import React, {useEffect} from 'react';
import {isMobile} from 'react-device-detect';

const MabalSubscriberList = (props) => {
  function getNumbersHtml() {
    return props.subscribers.map((number, index) => {
      return (
        <div className='mabal-sibscriber' key={index}>
          {number.replace(/^(.{3})(.*)$/, '$1-$2')}
        </div>
      );
    });
  }
  return (
    <div className={`${isMobile ? 'isMobile pr-0 pl-0' : ''}`}>
      <div className='semiBold main-text d-block w-100'>טלפונים הרשומים לשירות</div>
      <div className='w-100'>{getNumbersHtml()}</div>
    </div>
  );
};

export default MabalSubscriberList;
